var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "singLineBox"
  }, [_c("div", {
    staticClass: "card_box",
    class: {
      highlighted: _vm.item.isHighlighted,
      selected: _vm.item.isCheck
    },
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.toggleSelection(_vm.index, _vm.item);
      }
    }
  }, [_c("div", {
    staticClass: "nameBox"
  }, [_vm.item.isRequired ? _c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(_vm._s(_vm.$t(_vm.item.controlName)) + " "), _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t(_vm.item.controlExplain)) + " ")]), _vm.item.controlExplain ? _c("a-icon", {
    staticStyle: {
      margin: "0 3px"
    },
    attrs: {
      type: "question-circle"
    }
  }) : _vm._e()], 2), _c("div", [_c("span", [_vm._v(_vm._s(_vm.$t(_vm.item.prefix)))]), _c("a-input", {
    style: {
      width: _vm.item.widthSet
    },
    attrs: {
      placeholder: _vm.$t(_vm.item.promptText),
      readOnly: true
    }
  }), _c("span", [_vm._v(_vm._s(_vm.$t(_vm.item.suffix)))])], 1)], 1), _vm.item.isSelected ? [_c("control-action", {
    attrs: {
      "current-control-item": _vm.item,
      formDataArray: _vm.formDataArray,
      "current-control-index": _vm.index
    },
    on: {
      relationClick: _vm.relationClick,
      formeClick: _vm.formeClick
    }
  })] : _vm._e()], 2), _vm.item.editing ? [_c("a-form-model", {
    ref: "formData",
    attrs: {
      model: _vm.item,
      rules: _vm.rulesTrue
    }
  }, [_c("div", {
    staticClass: "box_nav"
  }, [_c("div", {
    staticClass: "title_name"
  }, [_vm._v(_vm._s(_vm.$t("名称设置")))]), _c("div", {
    staticClass: "nav_tit"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("控件名称"),
      prop: "controlName",
      labelCol: {
        span: 3
      }
    }
  }, [_c("a-input", {
    staticClass: "input_kjmc_7",
    attrs: {
      maxLength: 500
    },
    model: {
      value: _vm.item.controlName,
      callback: function ($$v) {
        _vm.$set(_vm.item, "controlName", $$v);
      },
      expression: "item.controlName"
    }
  })], 1), _c("div", {
    staticClass: "nav_item_q"
  }, [_c("div", {
    staticClass: "nav_qain"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("提示文字")
    }
  }, [_c("a-input", {
    staticClass: "input_left_right",
    model: {
      value: _vm.item.promptText,
      callback: function ($$v) {
        _vm.$set(_vm.item, "promptText", $$v);
      },
      expression: "item.promptText"
    }
  })], 1)], 1), _c("div", {
    staticClass: "nav_qain"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("控件说明")
    }
  }, [_c("a-input", {
    staticClass: "input_left_right",
    model: {
      value: _vm.item.controlExplain,
      callback: function ($$v) {
        _vm.$set(_vm.item, "controlExplain", $$v);
      },
      expression: "item.controlExplain"
    }
  })], 1)], 1)])], 1), _c("div", {
    staticClass: "title_name"
  }, [_vm._v(_vm._s(_vm.$t("控件值")))]), _c("div", {
    staticClass: "nav_tit"
  }, [_c("div", {
    staticClass: "nav_item_q ml_28"
  }, [_c("div", {
    staticClass: "nav_qain"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("前缀"),
      prop: "qianzhui"
    }
  }, [_c("a-input", {
    staticClass: "input_left_right",
    model: {
      value: _vm.item.prefix,
      callback: function ($$v) {
        _vm.$set(_vm.item, "prefix", $$v);
      },
      expression: "item.prefix"
    }
  })], 1)], 1), _c("div", {
    staticClass: "nav_qain ml_32"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("后缀"),
      prop: "suffix"
    }
  }, [_c("a-input", {
    staticClass: "input_left_right",
    model: {
      value: _vm.item.suffix,
      callback: function ($$v) {
        _vm.$set(_vm.item, "suffix", $$v);
      },
      expression: "item.suffix"
    }
  })], 1)], 1)]), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("属性校验")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "320px"
    },
    model: {
      value: _vm.item.attributeVerification,
      callback: function ($$v) {
        _vm.$set(_vm.item, "attributeVerification", $$v);
      },
      expression: "item.attributeVerification"
    }
  }, [_c("a-select-option", {
    attrs: {
      label: _vm.$t("单行文本"),
      value: "SINGLE_LINE"
    }
  }, [_vm._v(_vm._s(_vm.$t("单行文本")))]), _c("a-select-option", {
    attrs: {
      label: _vm.$t("数字"),
      value: "NUMBER"
    }
  }, [_vm._v(_vm._s(_vm.$t("数字")))]), _c("a-select-option", {
    attrs: {
      label: _vm.$t("手机号"),
      value: "PHONE"
    }
  }, [_vm._v(_vm._s(_vm.$t("手机号")))]), _c("a-select-option", {
    attrs: {
      label: _vm.$t("身份证号"),
      value: "IDCODE"
    }
  }, [_vm._v(_vm._s(_vm.$t("身份证号")))]), _c("a-select-option", {
    attrs: {
      label: _vm.$t("邮箱"),
      value: "email"
    }
  }, [_vm._v(_vm._s(_vm.$t("邮箱")))])], 1)], 1), _c("div", {
    staticClass: "nav_item_q"
  }, [_c("div", {
    staticClass: "nav_qain"
  }, [_vm.item.attributeVerification === "NUMBER" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("小数点位数")
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100px"
    },
    attrs: {
      "controls-position": "right",
      min: 0,
      max: 5
    },
    on: {
      blur: function ($event) {
        return _vm.xsdDefault1(_vm.index);
      }
    },
    model: {
      value: _vm.item.decimalPlaces,
      callback: function ($$v) {
        _vm.$set(_vm.item, "decimalPlaces", $$v);
      },
      expression: "item.decimalPlaces"
    }
  })], 1) : _vm._e()], 1), _c("div", {
    staticClass: "nav_qain"
  }, [_vm.item.attributeVerification === "NUMBER" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("数值限制")
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100px"
    },
    attrs: {
      "controls-position": "right",
      min: 0,
      max: 40000000
    },
    on: {
      blur: function ($event) {
        return _vm.szxzNumberMIN(_vm.index);
      },
      change: _vm.updateNumberMaxValue
    },
    model: {
      value: _vm.item.numberMinValue,
      callback: function ($$v) {
        _vm.$set(_vm.item, "numberMinValue", $$v);
      },
      expression: "item.numberMinValue"
    }
  }), _vm._v(" " + _vm._s(_vm.$t("至")) + " "), _c("a-input-number", {
    staticStyle: {
      width: "100px"
    },
    attrs: {
      "controls-position": "right",
      min: _vm.item.numberMinValue,
      max: 40000000
    },
    on: {
      blur: function ($event) {
        return _vm.szxzNumberMAX(_vm.index);
      }
    },
    model: {
      value: _vm.item.numberMaxValue,
      callback: function ($$v) {
        _vm.$set(_vm.item, "numberMaxValue", $$v);
      },
      expression: "item.numberMaxValue"
    }
  })], 1) : _vm._e()], 1)]), _c("div", {
    on: {
      click: function ($event) {
        return _vm.minMaxNav(_vm.index);
      }
    }
  }, [_vm.item.attributeVerification === "SINGLE_LINE" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("字数限制")
    }
  }, [_c("a-input-number", {
    attrs: {
      "controls-position": "right",
      min: 0,
      max: 199
    },
    on: {
      blur: function ($event) {
        return _vm.zsxzDefault1(_vm.index);
      }
    },
    model: {
      value: _vm.item.textMinLength,
      callback: function ($$v) {
        _vm.$set(_vm.item, "textMinLength", $$v);
      },
      expression: "item.textMinLength"
    }
  }), _vm._v(" " + _vm._s(_vm.$t("至")) + " "), _c("a-input-number", {
    attrs: {
      "controls-position": "right",
      min: _vm.item.textMinLength + 1,
      max: 200
    },
    on: {
      blur: function ($event) {
        return _vm.zsxzDefault2(_vm.index);
      }
    },
    model: {
      value: _vm.item.textMaxLength,
      callback: function ($$v) {
        _vm.$set(_vm.item, "textMaxLength", $$v);
      },
      expression: "item.textMaxLength"
    }
  })], 1) : _vm._e()], 1), _c("div", {
    staticClass: "nav_item_q"
  }, [_c("div", {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")])]), _c("div", {
    staticClass: "nav_qain"
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("宽度限制"),
      labelCol: {
        span: 3
      }
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "310px"
    },
    attrs: {
      placeholder: _vm.$t("请选择宽度")
    },
    model: {
      value: _vm.item.widthSet,
      callback: function ($$v) {
        _vm.$set(_vm.item, "widthSet", $$v);
      },
      expression: "item.widthSet"
    }
  }, [_c("a-select-option", {
    attrs: {
      label: _vm.$t("10%"),
      value: _vm.$t("10%")
    }
  }, [_vm._v(_vm._s(_vm.$t("10%")))]), _c("a-select-option", {
    attrs: {
      label: _vm.$t("20%"),
      value: _vm.$t("20%")
    }
  }, [_vm._v(_vm._s(_vm.$t("20%")))]), _c("a-select-option", {
    attrs: {
      label: _vm.$t("30%"),
      value: _vm.$t("30%")
    }
  }, [_vm._v(_vm._s(_vm.$t("30%")))]), _c("a-select-option", {
    attrs: {
      label: _vm.$t("40%"),
      value: _vm.$t("40%")
    }
  }, [_vm._v(_vm._s(_vm.$t("40%")))]), _c("a-select-option", {
    attrs: {
      label: _vm.$t("50%"),
      value: _vm.$t("50%")
    }
  }, [_vm._v(_vm._s(_vm.$t("50%")))]), _c("a-select-option", {
    attrs: {
      label: _vm.$t("60%"),
      value: _vm.$t("60%")
    }
  }, [_vm._v(_vm._s(_vm.$t("60%")))]), _c("a-select-option", {
    attrs: {
      label: _vm.$t("70%"),
      value: _vm.$t("70%")
    }
  }, [_vm._v(_vm._s(_vm.$t("70%")))]), _c("a-select-option", {
    attrs: {
      label: _vm.$t("80%"),
      value: _vm.$t("80%")
    }
  }, [_vm._v(_vm._s(_vm.$t("80%")))]), _c("a-select-option", {
    attrs: {
      label: _vm.$t("90%"),
      value: _vm.$t("90%")
    }
  }, [_vm._v(_vm._s(_vm.$t("90%")))]), _c("a-select-option", {
    attrs: {
      label: _vm.$t("100%"),
      value: _vm.$t("100%")
    }
  }, [_vm._v(_vm._s(_vm.$t("100%")))])], 1)], 1)], 1), _c("div", {
    staticClass: "nav_qain",
    staticStyle: {
      "margin-left": "20px",
      display: "flex"
    }
  }, [_c("div", {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_vm.item.isRequired ? _c("span", {
    staticClass: "itamNav"
  }, [_vm._v("*")]) : _vm._e()]), _c("div", [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("是否必填"),
      prop: ""
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.item.isRequired,
      callback: function ($$v) {
        _vm.$set(_vm.item, "isRequired", $$v);
      },
      expression: "item.isRequired"
    }
  }, [_c("a-radio", {
    attrs: {
      value: true
    }
  }, [_vm._v(_vm._s(_vm.$t("是")))]), _c("a-radio", {
    attrs: {
      value: false
    }
  }, [_vm._v(_vm._s(_vm.$t("否")))])], 1)], 1)], 1)])])], 1), _c("div", {
    staticClass: "title_name"
  }, [_vm._v(_vm._s(_vm.$t("其他")))]), _c("div", {}, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("标识"),
      prop: "mark"
    }
  }, [_c("a-input", {
    staticClass: "input_winth_100",
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.item.mark,
      callback: function ($$v) {
        _vm.$set(_vm.item, "mark", $$v);
      },
      expression: "item.mark"
    }
  })], 1)], 1), _c("div", {
    staticClass: "btn_close"
  }, [_c("a-button", {
    staticClass: "title_but",
    on: {
      click: function ($event) {
        return _vm.formeClase(_vm.index);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("关闭")))])], 1)])])] : _vm._e()], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };